import { CaregiverPhoneNumber } from "../messages/Caregiver";
import { formatPhone } from "../phone_number";

export function phoneNumbersString(phoneNumbers: CaregiverPhoneNumber[]): string {
  return phoneNumbers.map((p) => formatPhone(p.phoneNumber) + ` (${p.type})`).join(", ");
}
